import api from './api'

export default class PatchRequest {
  url: string

  body: any
  headers: Record<string, string> | undefined
  params: any | undefined
  timeout: number | undefined

  constructor(
    url: string,
    body: any,
    headers?: Record<string, string>,
    params?: any | undefined,
    timeout?: number
  ) {
    this.url = url
    this.body = body
    this.headers = headers
    this.params = params
    this.timeout = timeout
  }

  async run<R>() {
    return api.patch<R>(this.url, this.body, {
      headers: this.headers,
      params: this.params,
      timeout: this.timeout
    })
  }
}
